import { mergeByProp } from '@shared/utils/mergeByProp.js';
import createPersistedReducer from '../lib/createPersistedReducer';

const initialState = {
  issues: []
};

const persistConfig = {
  key: 'issuesReducer',
  whitelist: [],
  transforms: []
};

export default createPersistedReducer(
  initialState,
  {
    GET_APP_ISSUES_SUCCESS: (state, payload) => ({
      ...state,
      issues: [...state.issues.filter((issue) => issue?.appId !== payload?.meta?.appId), ...payload?.data]
    }),
    POST_ISSUE: (state, payload) => ({
      ...state,
      issues: [...state.issues, ...payload?.data]
    }),
    PUT_ISSUE: (state, payload) => ({
      ...state,
      issues: mergeByProp('id', state.issues, payload?.data)
    })
  },
  persistConfig
);
